import React from 'react';
import { Badge } from '../../components/ui/badge';

// Quotas de la grille du 21/09/2026 (mêmes chiffres que catalog.js et backend/plans.py).
const PLAN_FEATURES = {
  solo: ["1 compte Telegram", "5 membres d'équipe"],
  starter: ["2 comptes Telegram", "15 membres d'équipe"],
  business: ["5 comptes Telegram", "40 membres d'équipe"],
  enterprise: ["10 comptes Telegram", "Membres d'équipe illimités"],
};

// Les trois rythmes : combien de mois sont payés d'avance, et sous quelle clef de
// catalogue se trouve le prix correspondant.
const RYTHME = {
  month: { mois: 1, suffixe: null, label: null },
  quarter: { mois: 3, suffixe: '_quarterly', label: '−10 % tous les 3 mois' },
  year: { mois: 12, suffixe: '_yearly', label: "−20 % à l'année" },
};

export default function PlansGrid({ monthlyPlans, catalog, selectedKey, setSelectedKey, interval, fmtEUR, t }) {
  const r = RYTHME[interval] || RYTHME.month;
  return (
    <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
      {monthlyPlans.map((p) => {
        const active = p.key === selectedKey;
        const popular = p.key === 'starter';
        const prixPeriode = r.suffixe ? catalog.find((c) => c.key === `${p.key}${r.suffixe}`)?.price_eur : null;
        const displayPrice = prixPeriode ? prixPeriode / r.mois : p.price_eur;
        const features = PLAN_FEATURES[p.key] || [];

        let cardClass;
        if (active) cardClass = 'border-indigo-500 bg-indigo-500/[0.08] shadow-xl shadow-indigo-500/20 ring-2 ring-indigo-500/40';
        else if (popular) cardClass = 'border-indigo-500/30 bg-white/[0.02] hover:bg-white/[0.04]';
        else cardClass = 'border-white/10 bg-white/[0.02] hover:bg-white/[0.04]';

        return (
          <button
            type="button"
            key={p.key}
            onClick={() => setSelectedKey(p.key)}
            data-testid={`subscribe-plan-${p.key}`}
            className={`relative text-left rounded-2xl border p-5 transition-all hover:-translate-y-0.5 ${cardClass}`}
          >
            {popular && !active && <Badge className="absolute -top-2.5 left-1/2 -translate-x-1/2 bg-indigo-500 text-white border-0 text-[10px]">Le plus choisi</Badge>}
            {active && <Badge className="absolute -top-2.5 left-1/2 -translate-x-1/2 bg-emerald-500 text-white border-0 text-[10px]">✓ Choisi</Badge>}
            <div className="font-semibold text-white text-base mb-1">{p.name}</div>
            {r.label && (
              <div className="text-[10px] uppercase tracking-wider font-bold text-emerald-300 mb-2">{r.label}</div>
            )}
            <div className="flex items-baseline gap-1 mb-1">
              <span className="font-display text-3xl font-bold text-white">{fmtEUR(displayPrice)}</span>
              <span className="text-xs text-slate-500">{t('pricing.perMonth')}</span>
            </div>
            {prixPeriode && (
              <div className="text-[11px] text-slate-500 mb-3" data-testid={`subscribe-${p.key}-billed`}>
                {fmtEUR(prixPeriode)} facturé {interval === 'year' ? 'par an' : 'tous les 3 mois'}
              </div>
            )}
            <div className="text-[12px] text-slate-400 mt-3 space-y-1">
              {features.map((f) => <div key={f}>{f}</div>)}
            </div>
          </button>
        );
      })}
    </div>
  );
}
